import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'revenueCategory', 'priceLocked', 'priceField', 'openOnly'];

  connect() {
    this.API_BASE_URL = '/sandbar/admin'
    this.disableRevenueCategory();
    this.populateRevenueCategories()
  }

  // An open item takes its price from the operator, so the POS lock lifts as soon
  // as the box is ticked; fee only applies to open items.
  toggleOpen(event) {
    const open = event.target.checked
    if (this.hasPriceLockedTarget) this.priceLockedTarget.hidden = open
    if (this.hasPriceFieldTarget) {
      this.priceFieldTarget.hidden = !open
      this.priceFieldTarget.querySelector('input').disabled = !open
    }
    this.openOnlyTargets.forEach(target => {
      target.hidden = !open
    })
  }

  handleMenuChanged() {
    this.disableRevenueCategory();
    this.populateRevenueCategories();
  }

  disableRevenueCategory() {
    this.revenueCategoryTarget.disabled = true;
  }

  enableRevenueCategory() {
    this.revenueCategoryTarget.disabled = false;
  }

  async populateRevenueCategories() {
    this.revenueCategoryTarget.innerHTML = null;
    const categories = await this.fetchRevenueCategories();
    const categoryId = this.revenueCategoryTarget.dataset.categoryid

    this.revenueCategoryTarget.add(new Option('None', '', false, false));
    categories.forEach(category => {
      this.revenueCategoryTarget.add(new Option(category.name, category.id, false, categoryId === category.id.toString()));
    });
    this.enableRevenueCategory();
  }

  async fetchRevenueCategories() {
    try {
      const menu_id = this.hasMenuTarget ? this.menuTarget.value : this.revenueCategoryTarget.dataset.menuid
      const response = await fetch(`${this.API_BASE_URL}/revenue_categories.json?menu_id=${menu_id}`)
      return response.json();
    } catch (err) {
      console.error(err);
      return [];
    }
  }

}
